module.exports = __webpack_public_path__ + "static/media/emj23.961ee6ac.svg";